import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import addons from './addons';
import assortments from './assortments';
import env from './env';
import featureFlags from './featureFlags';
import user from './user';
import conflictsReducers from './downgradeConflicts';

const gaSettings = (state = {}) => state;
// EXPERIMENT_MARKER=LOW_ATV_UI
const showLowAtvUi = (state = false) => state;
const currencySymbol = (state = '') => state;
const localeDefaultPlan = (state = '') => state;

export default combineReducers({
    addons,
    form: formReducer,
    routing: routerReducer,
    assortments,
    env,
    featureFlags,
    user,
    gaSettings,
    showLowAtvUi,
    currencySymbol,
    localeDefaultPlan,
    ...conflictsReducers,
});
